export const CURRENT_PORTFOLIO_KEY = 'currentPortfolio';
export const RECOMMENDED_PORTFOLIO_KEY = 'recommendedPortfolio';
export const BENCHMARK_KEY = 'benchmark';
